import { render, staticRenderFns } from "./data4.vue?vue&type=template&id=5f34e81a&scoped=true&"
import script from "./data4.vue?vue&type=script&lang=js&"
export * from "./data4.vue?vue&type=script&lang=js&"
import style1 from "./data4.vue?vue&type=style&index=1&id=5f34e81a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f34e81a",
  null
  
)

export default component.exports